import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import withStyles from "@material-ui/core/styles/withStyles";
import Typography from "@material-ui/core/Typography";
import React, { Component, Fragment } from "react";
import "react-step-progress-bar/styles.css";



const styles = {
  root: {
    margin: "1.5em auto 1.5em auto",
  },
  linkText: {
    fontWeight: "100",
    color: "#e9a746",
    textDecoration: "none",
  },
};

class LinkCard extends Component {
  render() {
    const { classes } = this.props;
    const title = this.props.title;
    const linkName = this.props.linkName;
    const link = this.props.link;
    const groupName = this.props.groupName;
    return (
      <Card className={classes.root} variant="outlined">
        <CardContent>
          <Typography variant="h4">{title}</Typography>
          <Typography variant="body1">
            <a href={link} className={classes.linkText} target="_blank">
              {linkName}
            </a>
          </Typography>
          {groupName ? 
            <Typography>
              You are in Kada {groupName}
            </Typography> :
            <Fragment/>}
          
        </CardContent>
      </Card>
    );
  }
}

export default withStyles(styles)(LinkCard);
